import { Moment } from "moment";
import { useState, useEffect } from "react";
import { Payload } from "./Payload";
import { SpankOddsTeamInjuryReport } from "./Models";

export const useGameInjuries = (loggedIn: boolean | undefined) => {
  const [result, setResult] = useState<Payload<SpankOddsTeamInjuryReport[]>>({
    status: "init",
  });

  useEffect(() => {
    function getDetails() {
      fetch(`/api/GameInjuries`)
        .then((response) => response.json())
        .then((response) => setResult({ status: "loaded", payload: response }))
        .catch((error) => {
          console.log(error.toString());
          setResult({ status: "error", error });
        });
    }
    if (loggedIn === true) {
      getDetails();
      const interval = setInterval(() => getDetails(), 6000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [loggedIn]);

  return result;
};
